import { useEffect, useState } from "react";
import Test from "./Test";
import Packages from "./Packages";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCurrentPage,
  getApiParams,
} from "../ProviderProfileDetails/helper";
import {
  getHVChargesForAction,
  getTestTypeAction,
} from "../../../redux/actions/TestPackagesAction";
import {
  GetFacilityDropDownList,
  getProviderListNetworkAction,
  getSkuPackagesNetworkAction,
  getSkuTestPackagesNetworkAction,
  getTagListNetworkAction,
} from "../../../redux/actions/TestPackageNetworkAction";
import { getFacilityListAction } from "../../../redux/actions/ProviderProfileDetailAction";
import { initialFilterState } from "./Test/helper";
import { getNetworkMenuId } from "../../../Utils/types";

const TestPackagesNetwork = () => {
  const dispatch = useDispatch();
 
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });
  const [searchFilter, setSearchFilter] = useState(initialFilterState);
  const getFacilityDropdownList = useSelector(
    (state) => state?.TestPackageReducer?.getFacilityDropdownList
  );
  const [selectTestPackages, setSelectTestPackages] = useState(getFacilityDropdownList[0]?.facilityGroupName);
  useEffect(() => {
    dispatch(getHVChargesForAction());
    dispatch(getTestTypeAction());
    dispatch(getProviderListNetworkAction());
    dispatch(getTagListNetworkAction());
    dispatch(GetFacilityDropDownList());
    
  }, []);
  useEffect(()=>{
    if(getFacilityDropdownList[0]?.facilityGroupName){
      dispatch(getFacilityListAction(getFacilityDropdownList[0]?.facilityGroupName));
    setSelectTestPackages(getFacilityDropdownList[0]?.facilityGroupName)
    }
  },[getFacilityDropdownList])
  
  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <h4>
            {
              getFacilityDropdownList?.filter?.(ele => 
                ele?.facilityGroupName === selectTestPackages
              )[0]?.displayName
            }
          </h4>
          <div className=" select-test">
            <select
              value={selectTestPackages}
              onChange={(e) => {
                setSelectTestPackages(e?.target?.value);
                clearCurrentPage(dispatch);
                dispatch(getFacilityListAction(e?.target?.value));
                e.target.value === "Package"
                  ? dispatch(
                      getSkuPackagesNetworkAction({
                        ...searchFilter,
                        ...apiParams,
                      })
                    )
                  : dispatch(
                      getSkuTestPackagesNetworkAction({
                        ...searchFilter,
                        ...apiParams,
                        serviceName:
                          e.target.value === "SKU & Vaccination"
                            ? ""
                            : e.target.value,
                      })
                    );
              }}
            >
              {getFacilityDropdownList?.map((ele) => (
                <option value={ele?.facilityGroupName}>
                  {ele?.displayName}
                </option>
              ))}
            </select>
          </div>
          {selectTestPackages === "Package" ? (
            <Packages selectTestPackages={selectTestPackages} />
          ) : (
            <>
            {selectTestPackages ? <Test selectTestPackages={selectTestPackages}/> :""}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestPackagesNetwork;
